import { IComboBox, IComboBoxOption, Icon, IRenderFunction, ISelectableOption, Stack } from '@fluentui/react';
import { ComboBox, comboboxOptionText } from '@h2oai/ui-kit';
import { useCallback, useRef } from 'react';

import { FiltersSelectProps } from '../types';

const onRenderOption: IRenderFunction<ISelectableOption> = (item) => {
  if (!item) return null;

  return !!item?.data?.value ? (
    <span style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
      <span style={comboboxOptionText} title={item.text}>
        {item.text}
      </span>
      <Icon
        iconName="StatusCircleCheckmark"
        style={{ position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)', fontSize: 18 }}
      />
    </span>
  ) : (
    <span style={comboboxOptionText} title={item.text}>
      {item.text}
    </span>
  );
};

export const FiltersSelect = (props: FiltersSelectProps) => {
  const comboboxRef = useRef<IComboBox>(null);

  const handleChange = useCallback(
    (_e: unknown, option?: IComboBoxOption) => {
      props.onChange(option?.key as string | undefined);
    },
    [props.onChange]
  );

  const handleClick = useCallback(() => {
    comboboxRef.current?.focus(true);
  }, []);

  const selectedOptionText = props.options.find((option) => option.key === props.activeFilter)?.text || '';

  return (
    <Stack>
      <ComboBox
        text={selectedOptionText}
        label="Available Filters"
        useComboBoxAsMenuWidth
        selectedKey={props?.activeFilter}
        placeholder="Select filter"
        options={props.options}
        onChange={handleChange}
        componentRef={comboboxRef}
        onClick={handleClick}
        onRenderOption={onRenderOption}
      />
    </Stack>
  );
};
